import { render, staticRenderFns } from "./ProvinceAddress.vue?vue&type=template&id=6b615970&scoped=true"
import script from "./ProvinceAddress.vue?vue&type=script&lang=js"
export * from "./ProvinceAddress.vue?vue&type=script&lang=js"
import style0 from "./ProvinceAddress.vue?vue&type=style&index=0&id=6b615970&prod&lang=scss&scoped=true"
import style1 from "./ProvinceAddress.vue?vue&type=style&index=1&id=6b615970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b615970",
  null
  
)

export default component.exports